import { render } from "./Landing.vue?vue&type=template&id=6ccf67ce&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=6ccf67ce&scoped=true&lang=css"

import exportComponent from "/DATA/REPO/landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ccf67ce"]])

export default __exports__